import { render, staticRenderFns } from "./product_tb.vue?vue&type=template&id=6954f113&scoped=true&"
import script from "./product_tb.vue?vue&type=script&lang=js&"
export * from "./product_tb.vue?vue&type=script&lang=js&"
import style0 from "./product_tb.vue?vue&type=style&index=0&id=6954f113&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954f113",
  null
  
)

export default component.exports